import createReducer from '../utils/createReducer';
import {
  AFFILIATE_MAPPINGS_REQUEST,
  AFFILIATE_MAPPINGS_FAILURE,
  AFFILIATE_MAPPINGS_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [AFFILIATE_MAPPINGS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [AFFILIATE_MAPPINGS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [AFFILIATE_MAPPINGS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/affiliateMappings.js